<template>
    <div>
        <!-- <top-bar></top-bar> -->
<!--        <navigation-bar></navigation-bar>-->

        <!-- <div class="row">
            <div class="col">
                <Logo />
            </div>
        </div> -->

        <div id="page-wrapper" >
            <slot />
        </div>
    </div>
</template>

<script>
// import TopBar from "../components/TopBar";
// import NavigationBar from "../components/NavigationBar";
import Logo from "../components/Logo.vue"

export default {
    components: {
        Logo,
        // TopBar,
        // NavigationBar,
    },
}
</script>

<style lang="scss" scoped></style>